import CustomLayoutGeneralSettings from '@/components/CustomLayoutGeneralSettings';
import MediumText from '@/components/MediumText';
import RegularText from '@/components/RegularText';
import settingsSlice, { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimeZoneSelect from './TimeZoneSelect';
const TimeZone = ({ disableCardBorder }: { disableCardBorder?: boolean }) => {
  const dispatch = useDispatch();
  const dataSettings = useSelector(dataSettingsSelector);

  const description = 'Choose timezone on which date and time are based for calculation';

  return (
    <CustomLayoutGeneralSettings
      title="Timezone"
      isShowDivider
      description={disableCardBorder ? <MediumText>{description}</MediumText> : <RegularText>{description}</RegularText>}
    >
      <div className="mt-8">
        <TimeZoneSelect
          addition={[{ label: 'Default buyer timezone', value: '' }]}
          value={dataSettings?.date_timezone_offset || undefined}
          onChange={(value) =>
            dispatch(
              settingsSlice.actions.handleDataSettings({
                ...dataSettings,
                date_timezone_offset: value,
              }),
            )
          }
        />
      </div>
    </CustomLayoutGeneralSettings>
  );
};

export default memo(TimeZone);
